/**
 * Voyado Coming Soon — PDP notify form.
 * Subscribes via Shopify app proxy; never calls Voyado directly from the storefront.
 */
(function () {
  if (window.ComingSoonNotify && window.ComingSoonNotify.initialized) return;

  var SELECTOR = "[data-coming-soon-notify]";

  function normalizeLocale(raw) {
    if (!raw || typeof raw !== "string") return "";
    return raw.trim().replace(/_/g, "-");
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
  }

  function getMessage(root, key) {
    var tpl = root.querySelector("[data-coming-soon-msg-" + key + "]");
    if (!tpl) return "";
    if (tpl.tagName === "TEMPLATE" && tpl.content) {
      return tpl.content.textContent.trim();
    }
    return (tpl.textContent || "").trim();
  }

  function setStatus(root, type, message) {
    var status = root.querySelector("[data-coming-soon-status]");
    if (!status) return;
    status.hidden = !message;
    status.textContent = message || "";
    status.className =
      "coming-soon-notify__status coming-soon-notify__status--" +
      (type || "idle");
    if (message) {
      status.removeAttribute("hidden");
    } else {
      status.setAttribute("hidden", "");
    }
  }

  function setLoading(root, loading) {
    var btn = root.querySelector("[data-coming-soon-submit]");
    if (!btn) return;
    btn.disabled = !!loading;
    btn.classList.toggle("btn--loading", !!loading);
    btn.setAttribute("aria-busy", loading ? "true" : "false");
  }

  function updateSku(root, sku) {
    var next = sku || "";
    root.dataset.sku = next;
    var email = root.querySelector("[data-coming-soon-email]");
    if (email) {
      email.setAttribute(
        "aria-describedby",
        root.querySelector("[data-coming-soon-status]")?.id || "",
      );
    }
    if (!next) {
      setStatus(root, "error", getMessage(root, "missing-sku"));
    } else if (
      root
        .querySelector("[data-coming-soon-status]")
        ?.classList.contains("coming-soon-notify__status--error")
    ) {
      var msg = root.querySelector("[data-coming-soon-status]").textContent;
      if (msg === getMessage(root, "missing-sku")) {
        setStatus(root, "idle", "");
      }
    }
  }

  function resolveEndpoint(root) {
    return (root.dataset.endpoint || "/api/coming-soon").trim();
  }

  async function submitNotify(root) {
    var emailInput = root.querySelector("[data-coming-soon-email]");
    var honeypot = root.querySelector("[data-coming-soon-honeypot]");
    var email = emailInput ? emailInput.value.trim() : "";
    var locale = normalizeLocale(root.dataset.locale);
    var sku = (root.dataset.sku || "").trim();
    var website = honeypot ? honeypot.value : "";

    setStatus(root, "idle", "");

    if (website) {
      setStatus(root, "error", getMessage(root, "error"));
      return;
    }

    if (!isValidEmail(email)) {
      setStatus(root, "error", getMessage(root, "invalid-email"));
      if (emailInput) emailInput.focus();
      return;
    }

    if (!sku) {
      setStatus(root, "error", getMessage(root, "missing-sku"));
      return;
    }

    if (!locale) {
      setStatus(root, "error", getMessage(root, "error"));
      return;
    }

    setLoading(root, true);

    var controller = new AbortController();
    var timeoutId = setTimeout(function () {
      controller.abort();
    }, 20000);

    var headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };
    // Match the auth header the /api/member* endpoints send so the aimn-society
    // backend authorizes this request the same way (avoids 401 Unauthorized).
    var shopDomain = (root.dataset.shopDomain || "").trim();
    if (shopDomain) {
      headers["x-shopify-shop-domain"] = shopDomain;
    }

    try {
      var res = await fetch(resolveEndpoint(root), {
        method: "POST",
        headers: headers,
        credentials: "same-origin",
        signal: controller.signal,
        body: JSON.stringify({
          email: email,
          locale: locale,
          sku: sku,
          productId: root.dataset.productId || undefined,
          website: website,
        }),
      });

      clearTimeout(timeoutId);

      var body = {};
      try {
        body = await res.json();
      } catch (e) {
        body = {};
      }

      if (res.ok && body.ok) {
        if (body.alreadySubscribed) {
          setStatus(root, "already", getMessage(root, "already"));
        } else {
          setStatus(root, "success", getMessage(root, "success"));
        }
        return;
      }

      if (res.status === 409 || body.code === "ALREADY_SUBSCRIBED") {
        setStatus(root, "already", getMessage(root, "already"));
        return;
      }

      if (res.status === 400 && body.code === "INVALID_EMAIL") {
        setStatus(root, "error", getMessage(root, "invalid-email"));
        return;
      }

      if (res.status === 400 && body.code === "MISSING_SKU") {
        setStatus(root, "error", getMessage(root, "missing-sku"));
        return;
      }

      setStatus(root, "error", getMessage(root, "error"));
    } catch (err) {
      clearTimeout(timeoutId);
      setStatus(root, "error", getMessage(root, "error"));
    } finally {
      setLoading(root, false);
    }
  }

  function bindAll(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(function (root) {
      updateSku(root, root.dataset.sku || "");
    });
  }

  function onVariantChange(evt) {
    var variant = evt && evt.detail && evt.detail.variant;
    if (!variant) return;
    document.querySelectorAll(SELECTOR).forEach(function (root) {
      if (root.dataset.lockSku === "true") return;
      var sectionId = root.dataset.sectionId;
      if (!sectionId) return;
      var variantJsonEl =
        document.getElementById("CurrentVariantJson-" + sectionId) ||
        document.getElementById("VariantsJson-" + sectionId);
      if (!variantJsonEl) {
        updateSku(root, variant.sku || "");
        return;
      }
      updateSku(root, variant.sku || "");
    });
  }

  var OVERLAY_SELECTOR = "[data-coming-soon-overlay]";

  function openOverlay(targetId) {
    var overlay = targetId && document.getElementById(targetId);
    if (!overlay) return;
    if (overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }
    overlay.hidden = false;
    document.body.classList.add("bis-overlay-open");
    var closeBtn = overlay.querySelector(".js-coming-soon-overlay-close");
    if (closeBtn) closeBtn.focus();
  }

  function closeOverlay(overlay) {
    if (!overlay) return;
    overlay.hidden = true;
    if (!document.querySelector(OVERLAY_SELECTOR + ":not([hidden])")) {
      document.body.classList.remove("bis-overlay-open");
    }
  }

  document.addEventListener("click", function (e) {
    var openBtn = e.target.closest(".js-coming-soon-notify-btn");
    if (openBtn) {
      e.preventDefault();
      e.stopPropagation();
      openOverlay(
        openBtn.getAttribute("data-overlay-target") ||
          openBtn.dataset.overlayTarget,
      );
      return;
    }

    var closeEl = e.target.closest(".js-coming-soon-overlay-close");
    if (closeEl) {
      closeOverlay(closeEl.closest(OVERLAY_SELECTOR));
      return;
    }

    var btn = e.target.closest("[data-coming-soon-submit]");
    if (!btn) return;
    var root = btn.closest(SELECTOR);
    if (root) submitNotify(root);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var open = document.querySelectorAll(OVERLAY_SELECTOR + ":not([hidden])");
    open.forEach(function (overlay) {
      closeOverlay(overlay);
    });
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Enter") return;
    var input = e.target.closest("[data-coming-soon-email]");
    if (!input) return;
    var root = input.closest(SELECTOR);
    if (root) {
      e.preventDefault();
      submitNotify(root);
    }
  });

  bindAll(document);

  document.addEventListener("variant:change", onVariantChange);
  document.addEventListener("variantChange", onVariantChange);

  document.addEventListener("shopify:section:load", function () {
    bindAll(document);
  });

  document
    .querySelectorAll("form.product-single__main-form")
    .forEach(function (form) {
      if (!form.querySelector("[data-coming-soon-blocked]")) return;
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
    });

  window.ComingSoonNotify = {
    initialized: true,
    bindAll: bindAll,
    updateSku: updateSku,
  };
})();
